import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  return <section className="py-14 md:py-20 bg-dark text-white relative overflow-hidden" data-id="element-252">
      {/* Background glow effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-rose-900/30 rounded-full blur-[100px] pointer-events-none" data-id="element-253"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-254">
        <div className="text-center mb-10" data-id="element-255">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-gold-400 font-bold tracking-widest uppercase mb-4" data-id="element-256">
            Presentamos:
          </motion.p>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-6xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-white via-rose-100 to-white" data-id="element-257">
            Mensajes Magnéticos
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl md:text-2xl italic text-rose-200 font-heading max-w-2xl mx-auto" data-id="element-258">
            "El sistema que hace que él te busque, te desee y te priorice"
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-259">
          {/* Left: Product Mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative flex justify-center perspective-1000" data-id="element-260">
            {/* Product Image */}
            <img src="https://cdn.magicpatterns.com/uploads/2SGtEYHkMUysq1V76bLXKx/portada.optimizada.webp" alt="Mensajes Magnéticos - Producto Digital" loading="lazy" decoding="async" className="w-64 md:w-80 rounded-2xl shadow-2xl" data-id="element-261" />

            {/* Glow behind product */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-rose-500/20 blur-2xl -z-10" data-id="element-262"></div>
          </motion.div>

          {/* Right: Features & Copy */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col space-y-8" data-id="element-263">
            <div className="flex flex-col space-y-4" data-id="element-264">
              <div className="flex items-center space-x-3 bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-265">
                <div className="w-2 h-2 rounded-full bg-gold-400" data-id="element-266"></div>
                <span className="text-lg font-medium" data-id="element-267">
                  <strong data-id="element-268">+100 Mensajes</strong> Listos
                </span>
              </div>
              <div className="flex items-center space-x-3 bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-269">
                <div className="w-2 h-2 rounded-full bg-gold-400" data-id="element-270"></div>
                <span className="text-lg font-medium" data-id="element-271">
                  Método en <strong data-id="element-272">3 Pasos</strong>
                </span>
              </div>
              <div className="flex items-center space-x-3 bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-273">
                <div className="w-2 h-2 rounded-full bg-gold-400" data-id="element-274"></div>
                <span className="text-lg font-medium" data-id="element-275">
                  Resultados desde el <strong data-id="element-276">primer uso</strong>
                </span>
              </div>
            </div>

            <div className="border-l-4 border-rose-500 pl-6 space-y-4" data-id="element-277">
              <p className="text-xl text-gray-300 leading-relaxed" data-id="element-278">
                Deja de improvisar y empieza a usar mensajes diseñados para{' '}
                <strong data-id="element-279">activar su interés</strong>…
              </p>
              <p className="text-xl text-white font-bold underline decoration-rose-500/50 underline-offset-4" data-id="element-280">
                incluso si ahora mismo él está distante.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}